export { default as LifestylesIndexPageCategoriesNavAmountButton } from './LifestylesIndexPageCategoriesNavAmountButton';
